import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "~/foundation/components/Switch";
import { Text } from "~/foundation/components/Text";

const SETTINGS = [
  {
    id: "sso-required",
    label: "Require single sign-on",
    description: "Members must sign in through the configured identity provider.",
    value: false,
  },
  {
    id: "invite-required",
    label: "Invite required",
    description: "Nobody can join by email domain alone — someone must invite them.",
    value: true,
  },
  {
    id: "public-sharing",
    label: "Allow public sharing",
    description: "Members may create links that work without signing in.",
    value: true,
  },
  {
    id: "viewer-export",
    label: "Let viewers export",
    description: "Read-only members can download documents.",
    value: false,
  },
];

export function Security() {
  const { t } = useTranslation();
  const [settings, setSettings] = useState(SETTINGS);

  return (
    <div className="flex flex-col gap-3">
      <Text variant="small">
        {t(
          "These are enforced by the server. Turning one off here does not relax it anywhere else.",
        )}
      </Text>

      <div className="rounded-md border border-divider px-4">
        {settings.map((setting, index) => (
          <div key={setting.id} className={index > 0 ? "border-t border-divider" : undefined}>
            <Switch
              checked={setting.value}
              onCheckedChange={(value) =>
                setSettings((current) =>
                  current.map((s) => (s.id === setting.id ? { ...s, value } : s)),
                )
              }
              label={t(setting.label)}
              description={t(setting.description)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
